import type BaseRestResponse from '../schema/BaseRestResponse';

export function handleServerErrorResponse(
    response: BaseRestResponse | undefined | null
): Promise<void> {
    let ErrorMessage = 'Unknown Error';

    if (!response) {
        ErrorMessage = 'Null Response';
        return Promise.reject(ErrorMessage);
    } else if (!response?.Success) {
        ErrorMessage = response.ErrorMessage;
        return Promise.reject(ErrorMessage);
    }

    return Promise.reject(ErrorMessage);
}
